export default __webpack_public_path__ + "static/icon-1-2-5e3539df610e087583316a05d07068e5.png";